import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Spinner } from 'reactstrap';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { callApi } from '../../ApiHelper/ApiHelper';
import { toast } from 'react-toastify';
import moment from 'moment';
import { formatAmount } from '../../utility/CommonFunctions';
import { useNavigate } from 'react-router-dom';
import { RoutesLink } from '../../ApiHelper/RoutesLink';

const FreezedAmountDetailModal = ({ isOpen, toggle, selectedItem }) => {
    if (!selectedItem) return null;

    const [freezedAmountDetail, setFreezedAmountDetail] = useState({});
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen == true) {
            GetFreezedAmountDetail();
        }
    }, [isOpen]);

    const GetFreezedAmountDetail = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl?.get_freezed_amount_detail + `?siteBudgetId=${selectedItem?.id}`;
        setIsLoadingDetail(true);
        callApi(API, options).then((response) => {
            setIsLoadingDetail(false);
            if (response?.status === true) {
                setFreezedAmountDetail(response?.data);
            } else {
                toast.error(response?.message);
            }
        });
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} scrollable centered size="lg" >
            <ModalHeader toggle={toggle} className="border-0 pb-2 pt-4 px-4 bg-white rounded-top-4" tag="div">
                <h3 className="fw-bolder mb-1 text-dark pe-4 d-flex align-items-center gap-3" style={{ letterSpacing: "-0.5px" }}>
                    <span>{selectedItem?.expensehead?.name || "Expense Head"}</span>
                    <span className="badge bg-secondary-subtle text-secondary border border-secondary-subtle px-3 py-2 rounded-pill fw-bold" style={{ fontSize: "13px" }}>
                        Total Freezed: {formatAmount(selectedItem?.freezedAmount || 0)}
                    </span>
                </h3>
            </ModalHeader>
            <ModalBody className="px-4 pb-4 pt-3" style={{ backgroundColor: '#f8fafc' }}>
                {isLoadingDetail ? (
                    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "300px" }}>
                        <Spinner color="primary" />
                    </div>
                ) : (
                    <div className="w-100">
                        <div className="d-flex flex-column gap-3">
                            {Array.isArray(freezedAmountDetail) && freezedAmountDetail.length > 0 ? (
                                freezedAmountDetail.map((item, index) => (
                                    <div
                                        key={item?.id || index}
                                        className="card border-0 shadow-sm rounded-4 overflow-hidden"
                                        style={{ transition: 'all 0.2s ease', backgroundColor: '#ffffff' }}
                                    >
                                        <div className="card-body p-4 d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="bg-primary-subtle rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '48px', height: '48px' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="text-primary" viewBox="0 0 16 16">
                                                        <path d="M14.5 3a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h13zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z" />
                                                        <path d="M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <h5 className="mb-1 fw-bold text-dark" style={{ fontSize: '15px' }}>
                                                        {item?.itemName}
                                                    </h5>
                                                    <div className="text-muted d-flex align-items-center gap-2" style={{ fontSize: '12px', fontWeight: '500' }}>
                                                        <span>{item?.poId ? "PO" : "PT"}:</span>
                                                        <span
                                                            className='text-primary fw-bold text-decoration-underline me-2'
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (item?.poId) {
                                                                    const baseUrl = import.meta.env.VITE_PUBLIC_URL || "";
                                                                    const targetUrl = `${baseUrl}${RoutesLink.purchase_order_detail}/${item?.poId}`.replace(/\/\//g, '/');
                                                                    window.open(targetUrl, '_blank');
                                                                } else {
                                                                    const baseUrl = import.meta.env.VITE_PUBLIC_URL || "";
                                                                    const targetUrl = `${baseUrl}${RoutesLink.payment_tickets_details}/general/${item?.ticketId}`.replace(/\/\//g, '/');
                                                                    window.open(targetUrl, '_blank');
                                                                }
                                                            }}
                                                        >
                                                            {item?.poId ? item?.poNumber : item?.ticketNumber}
                                                        </span>
                                                        {item?.poId &&
                                                            <>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                                                    <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                                </svg>
                                                                <span>{item?.poDate ? moment(item.poDate).format("DD MMM YYYY") : "N/A"}</span>
                                                            </>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-end">
                                                <div className="text-muted text-uppercase mb-1" style={{ fontSize: '10px', letterSpacing: '0.5px', fontWeight: '600' }}><span>Freezed Amount</span></div>
                                                <div className="fw-bolder text-primary" style={{ fontSize: '18px', letterSpacing: '-0.5px' }}>
                                                    <span>{formatAmount(item?.totalFreezedAmount || 0)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : null}
                        </div>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default FreezedAmountDetailModal;
